/**
 * The Overview's one line about automation (Feature 74 D7): how many
 * linkages are on here, and how many warnings stand, opening the
 * organization's Automation page, where the switches now live.
 */
import { Link } from 'react-router-dom';

import { Band } from '../../ui/Band.js';
import { useOrgAutomations } from './useOrgAutomations.js';

const BAND_STYLE = { marginTop: 30, marginBottom: 11 };

export function AutomationSummary({ orgId }: { orgId: string }) {
  const { on, warnings, loading } = useOrgAutomations(orgId);
  return (
    <>
      <Band label="Automation" style={BAND_STYLE} />
      <Link
        to={`/orgs/${orgId}/automation`}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 9,
          padding: '13px 16px',
          borderRadius: 'var(--radius-card)',
          border: '1px solid var(--border-hairline)',
          background: 'var(--surface-card)',
          color: 'var(--text-strong)',
          textDecoration: 'none',
        }}
      >
        <span style={{ flex: 1 }}>
          {loading ? (
            'Reading what runs here…'
          ) : (
            <>
              <span className="mono" style={{ fontWeight: 'var(--weight-semibold)' }}>
                {on}
              </span>{' '}
              automation{on === 1 ? '' : 's'} on
              <span style={{ color: 'var(--text-faint)' }}> · </span>
              <span
                style={
                  warnings > 0
                    ? { color: 'var(--warn)', fontWeight: 'var(--weight-semibold)' }
                    : { color: 'var(--text-soft)' }
                }
              >
                <span className="mono">{warnings}</span> warning{warnings === 1 ? '' : 's'}
              </span>
            </>
          )}
        </span>
        <span style={{ color: 'var(--accent)', fontWeight: 'var(--weight-medium)' }}>
          Open Automation
        </span>
      </Link>
    </>
  );
}
